import { DefaultButton, DetailsList, DetailsListLayoutMode, Dialog, DialogFooter, DialogType, FontIcon, IColumn, Icon, Panel, PanelType, PrimaryButton, ProgressIndicator, SelectionMode, TextField } from '@fluentui/react';
import React, { useEffect, useState } from 'react'
import IPERCService from '../../../../services/IPERCService';
import HelpersIpercBase from '../../../../utils/helpers/HelpersIpercBase';
import COLORES from '../../../../utils/theme/colores';
import ActividadService from '../../../../services/Iperc/ActividadService';
import { IDataActividades } from '../../../../Interfaces/IPERC/IActividad';

export const PanelActividadesPorEquipo = (props: any) => {

    const [itmesPanel, setItemsPanel] = useState<IDataActividades[]>([]);
    const [equipoId, setEquipoId] = useState("");

    const _columnsPanel: IColumn[] = [
        {
            key: "nombre",
            name: "Actividad",
            fieldName: "nombre",
            minWidth: 300,
            maxWidth: 400,
            isResizable: true,
            isMultiline: true,
        },
        {
            key: "created",
            name: "Fecha de creación",
            fieldName: "created",
            minWidth: 300,
            maxWidth: 400,
            isResizable: true,
            isMultiline: true,
        },
        {
            key: "opciones",
            name: "Opciones",
            fieldName: "opciones",
            minWidth: 70,
            maxWidth: 90,
            isResizable: true,
            isCollapsible: true,
            data: "number",
            //   onRender: (item: IPERCUbicacion) => (
            //     <>
            //       <TooltipHost content={"Eliminar"}>
            //         <Icon
            //           iconName="Trash"
            //           className={classNames.iconFont}
            //           style={{ cursor: "pointer", color: "red" }}
            //           onClick={() => {
            //             toggleHideDialogDelete2();
            //             setSelectedNivel(item.ubicacionId);
            //             setmodel({ ...model, ubicacionId: item.ubicacionId });
            //           }}
            //         />
            //       </TooltipHost>
            //     </>
            //   ),
        },
    ];

    function LoadData2() {
        ActividadService.getActividadesPorEquipo(props.equipoId).then((x) => {
            setItemsPanel(x.data);
        });
    }

    useEffect(() => {
        if (props.equipoId) {

            LoadData2()
        }
    }, [props.equipoId]);


    return (
        <>
            <Panel
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                type={PanelType.medium}
                closeButtonAriaLabel="Close"
                headerText="Actividades"
                // onRenderFooterContent={onRenderFooterContent2}
                isFooterAtBottom={true}
            >
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                        <br />
                        {/* <TextField
                            {...HelpersIpercBase.TextTextFieldElevation}
                            value={model.nombre}
                            onChange={_onChange}
                            onRenderPrefix={(arg) => (
                                <FontIcon
                                    iconName="Rename"
                                    style={{ color: COLORES.Bases.primary }}
                                />
                            )}
                            placeholder="Ingrese nombre de nivel *"
                        /> */}
                    </div>

                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <br />
                    <DetailsList
                        items={itmesPanel}
                        compact={false}
                        selectionMode={SelectionMode.none}
                        columns={_columnsPanel}
                        setKey="set"
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionPreservedOnEmptyClick={true}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="select row"
                    />
                </div>
                {/* <Dialog
                    hidden={hideDialog2}
                    onDismiss={toggleHideDialog2}
                    dialogContentProps={{
                        title: "Enviando Información",
                        type: DialogType.normal,
                        subText: "Por favor espere un momento",
                    }}
                >
                    <ProgressIndicator barHeight={5} />
                </Dialog> */}

                {/* <Dialog
                    hidden={hideDialogSuccess2}
                    onDismiss={toggleHideDialogSuccess2}
                    dialogContentProps={{
                        title: "Proceso Correcto",
                        subText: "Su solicitud se procesó correctamente!",
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <div style={{ width: "42px", height: "42px", margin: "0 auto" }}>
                            <Icon
                                iconName="Accept"
                                style={{
                                    color: theme.palette.themePrimary,
                                }}
                                className="ms-fontSize-42"
                            ></Icon>
                        </div>
                    </div>

                    <DialogFooter>
                        <PrimaryButton
                            onClick={() => {
                                toggleHideDialogSuccess2();
                                // setOpenPanel2(false);
                            }}
                            text="Aceptar"
                        />
                    </DialogFooter>
                </Dialog>
                <Dialog
                    hidden={hideDialogError2}
                    onDismiss={toggleHideDialogError2}
                    dialogContentProps={{
                        title: "Error en Solicitud",
                        subText: "Hubo un problema con la información enviada!",
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <div
                            style={{
                                width: "42px",
                                height: "42px",
                                margin: "0 auto",
                            }}
                        >
                            <Icon
                                iconName="ErrorBadge"
                                style={{
                                    color: theme.palette.redDark,
                                }}
                                className="ms-fontSize-42"
                            ></Icon>
                        </div>
                    </div>

                    <DialogFooter>
                        <DefaultButton onClick={toggleHideDialogError2} text="Aceptar" />
                    </DialogFooter>
                </Dialog>
                <Dialog
                    hidden={hideDialogDelete2}
                    onDismiss={toggleHideDialogDelete2}
                    dialogContentProps={{
                        title: "Eliminando...",
                        subText:
                            "¿Está seguro que desea eliminar?, el registro se eliminará permanentemente.",
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton
                            onClick={() => {
                                var body: any = {};
                                body.id = selectedNivel;
                                IPERCService.eliminarUbicacion(body).then((x) => {
                                    toggleHideDialogDelete2();
                                    LoadData2(selectedUbicacion);
                                });
                            }}
                            text="Aceptar"
                        />
                        <DefaultButton
                            onClick={() => {
                                toggleHideDialogDelete2();
                                LoadData2(model.ubicacionId);
                            }}
                            text="Cancelar"
                        />
                    </DialogFooter>
                </Dialog> */}
            </Panel>
        </>
    )
}
